import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationStart, Router } from '@angular/router';
import { DialogRef, ModalComponent } from 'angular2-modal';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { CountryService } from '../../commonservice/countrylist.service';
import { utilityService } from '../../commonservice/utility.service';
import { AppSettings } from '../../_common/constants/app.constants';
import { CountryDetail } from './countryinformation';
export class CustomModalContext extends BSModalContext {
  public modalData: any;
}
@Component({
  selector: 'app-statelist',
  templateUrl: 'statelist.component.html',
  providers: [Modal, CountryService, utilityService]
})
export class StatelistComponent implements OnInit, ModalComponent<CustomModalContext> {
  model: any = {};
  isMore = false; // For Expanding state list class
  context: CustomModalContext;
  modalData: any;
  countryinfo: CountryDetail;
  preferredCountrycollection = [];
  countrycollection = [];
  appSettings: any;
  countryCode: string = 'MX';
  filteredData$: Observable<any>;
  data$: Observable<any>;
  constructor(
    private router: Router,
    private countryserv: CountryService,
    public utilserv: utilityService,
    public dialog: DialogRef<CustomModalContext>,
    public domSanitizer: DomSanitizer,
    public translate: TranslateService
  ) {
    this.modalData = this.dialog.context.modalData;
    this.countryCode = this.dialog.context.modalData.CountryCode;
    this.dialog.context.modalData.next = {};
    this.getcountrylistfromservice();
    this.appSettings = AppSettings;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.close();
      }
    });
  }
  ngOnInit() {}
  // Function will intitated Country List and Save on a session variable going forward will use this for getting Country related information
  getcountrylistfromservice() {
    this.countrycollection = this.countryserv.getCountryListFromLocaleEx();
    let statesObj=this.countrycollection.filter(item => item.CountryCode == this.countryCode)
    if(statesObj.length>0){
      let filterstates = this.countrycollection.filter(item => item.CountryCode == this.countryCode)[0].states;
      if (this.modalData.StateCollection != undefined && this.modalData.StateCollection.length > 0) {
        filterstates = this.modalData.StateCollection;
      }
      this.data$ = Observable.of(filterstates);
    }

    this.filteredData$ = this.data$;
  }
  onkeypress(value) {
    this.filteredData$ = this.data$.map(x => {
      return x.filter(y => {
        return y.StateAlias.find(state => state.toLowerCase().indexOf(value.toLowerCase()) > -1);
      });
    });
  }

  onSelect(state) {
    this.dialog.context.modalData.next = state;
    this.dialog.close();
  }
  closePopup() {
    this.dialog.close();
  }
  switchClass(object) {
    this.isMore = true;
    if (object.currentTarget.title === 'more') {
      document.getElementById('_content').classList.add('showContent');
      document.getElementById('_content').classList.remove('hideContent');
    } else {
      document.getElementById('_content').classList.add('hideContent');
      document.getElementById('_content').classList.remove('showContent');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_common/countrylist/statelist.component.ts